export default __webpack_public_path__ + "static/media/Login-trivias.bcda86ee.jpg";